import script from "./AdminEntityDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEntityDetail.vue?vue&type=script&setup=true&lang=js"

import "./AdminEntityDetail.vue?vue&type=style&index=0&id=d5e2bbb2&lang=scss&scoped=true"
import "./AdminEntityDetail.vue?vue&type=style&index=1&id=d5e2bbb2&lang=scss"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5e2bbb2"]])

export default __exports__